import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UiModule } from 'src/app/ui';
import { PublishingState } from '../../states/publishing.state';

@Component({
  selector: 'rk-android-screenshot',
  imports: [AsyncPipe, TranslatePipe, UiModule],
  templateUrl: './android-screenshot.component.html',
  styleUrl: './android-screenshot.component.scss',
})
export class AndroidScreenshotComponent {
  window = window;
  androidScreenshot$: Observable<string> = inject(Store).select(
    PublishingState.androidScreenshot,
  );
  playStoreLink$: Observable<string> = inject(Store).select(
    PublishingState.playStoreLink,
  );
}
